function PlotterData(datasets, options) {
  Array.apply(this)

  this.powers = Object.fromEntries(
    Object.keys(options.powers).map(k => [k, options.powers[k] || 1])
  )
  this.range = {
    x: [Infinity, -Infinity],
    y: [Infinity, -Infinity],
    z: [Infinity, -Infinity],
  }
  this.sizeAttr = datasets.size.length > 0

  const headers = datasets.main[0]
  datasets.main = datasets.main.slice(1)
  datasets.pair = datasets.pair.slice(1)
  datasets.size = datasets.size.slice(1)
  this.headers = headers.reduce((acum, header, i) => {
    acum[header] = i
    return acum
  }, {})

  Array.prototype.unshift.call(this, Object.keys(this.fields))

  const allDates = Object.keys(
    options.dates.main
      .concat(options.dates.pair)
      .concat(options.dates.size)
      .reduce((acum, date) => {
        acum[date.getTime()] = []
        return acum
      }, {})
  )
    .map(Number)
    .sort((a, b) => a - b)

  const model = options.countries.main
    .concat(options.countries.pair)
    .concat(options.countries.size)
    .reduce((acum, iso) => {
      acum[iso] = acum[iso] || Array.apply(null, Array(allDates.length))
      return acum
    }, {})

  const labels = {}
  const rowOrder = {
    main: 0,
    pair: 1,
    size: 2,
  }
  Object.keys(datasets).forEach(key => {
    if (key === 'size' && datasets.size.length === 0) {
      for (let country in model) {
        for (let row of model[country]) {
          if (row) row[2] = 1
        }
      }
    } else {
      datasets[key].forEach(row => {
        let country = row[this.headers._ISO3_]
        let date = row[this.headers._DATE_]
        let label = row[this.headers._COUNTRY_]
        if (model[country] === undefined) return
        const dateIndex = allDates.indexOf(date.getTime())
        model[country][dateIndex] = model[country][dateIndex] || Array(3)
        model[country][dateIndex][rowOrder[key]] = row[this.headers._VALUE_]
        labels[country] = label
      })
    }
  })

  if (options.lastDates) {
    const lastCommonDate = Math.min(
      Math.max(...options.dates.main),
      Math.max(...options.dates.pair),
      options.dates.size.length ? Math.max(...options.dates.size) : Infinity
    )
    this.toLastAvailables(model, allDates.indexOf(lastCommonDate), this.timeScale, allDates)
    allDates.splice(0, allDates.length)
    allDates.push(lastCommonDate)
  }

  this.dataset = Object.keys(model).reduce((acum, country) => {
    model[country].forEach((row, i) => {
      if (row && row[0] && row[1] && row[2]) {
        const dates = row.dates
          ? ['main', 'pair', 'size'].map(k => new Date(+row.dates[k]))
          : Array.apply(null, Array(3)).map(() => new Date(+allDates[i]))
        acum.push([country, labels[country], new Date(Math.max(...dates)), ...row, dates])
      }
    })
    return acum
  }, [])

  this.dataset.countries = Object.fromEntries(Object.keys(model).map(d => [d, true]))
  this.dataset.dates = this.dataset.reduce((acum, row) => {
    acum[row[this.fields._DATE_].getTime()] = true
    return acum
  }, {})
  this.countries = {}
  this._columns = function(row) {
    return row
  }
}

PlotterData.prototype = Object.create(Array.prototype)

PlotterData.prototype.fields = {
  _COUNTRY_: 0,
  _LABEL_: 1,
  _DATE_: 2,
  _X_: 3,
  _Y_: 4,
  _SIZE_: 5,
  _X_DATE_: 6,
  _Y_DATE_: 7,
  _SIZE_DATE_: 8,
}

PlotterData.prototype.columns = function(fn) {
  this._columns = fn
  return this
}

PlotterData.prototype.select = function(fn) {
  for (let row of this.dataset) {
    let isSelected = fn(row, this.fields)
    if (isSelected) this.push(this._columns(row, this.fields))
    if (isSelected !== false) {
      this.countries[this._columns(row, this.fields)[this.fields._COUNTRY_]] = true
    }
  }

  return this
}

PlotterData.prototype.push = function(row) {
  Array.prototype.push.call(
    this,
    row.map((v, i) => {
      switch (i) {
        case this.fields._X_:
          v = v * this.powers.main
          this.range.x = this.updateRange(this.range.x, v)
          return v
        case this.fields._Y_:
          v = v * this.powers.pair
          this.range.y = this.updateRange(this.range.y, v)
          return v
        case this.fields._SIZE_:
          this.range.z = this.updateRange(this.range.z, v)
          return v * this.powers.size
        default:
          return v
      }
    })
  )
  this.countries[row[this.fields._COUNTRY_]] = true
  return this
}

PlotterData.prototype.toLastAvailables = function(model, refDateIdx, timeScale, dates) {
  const cols = ['main', 'pair', 'size']
  Object.keys(model).forEach(country => {
    const mergedRow = [null, null, null]
    mergedRow.dates = {}
    for (let i = 0; i <= 3; i++) {
      const dateIdx = refDateIdx - (3 - i)
      const row = model[country][dateIdx]
      if (row) {
        row.forEach((v, i) => {
          mergedRow[i] = row[i] != null ? row[i] : mergedRow[i]
          if (mergedRow[i] === row[i]) mergedRow.dates[cols[i]] = new Date(+dates[dateIdx])
        })
      }
    }
    model[country] = [mergedRow]
  })
}

PlotterData.prototype.updateRange = function(range, val) {
  if (!val || isNaN(val) || !isFinite(val)) return range
  return [Math.min(range[0], +val), Math.max(range[1], +val)]
}

export default PlotterData
